import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import VideoPlayer from '@bd/bdui-videoplayer';
import { Image } from '@bd/bdcore-utilities';
import { Link as RRLink } from 'react-router-dom';
import { typography, colors } from '../../../styles';
import Carousel from '../../Carousel';
import ButtonSet from '../../ButtonSet';

const styles = css`
  .HomePageHeroImage_imageWrapper {
    width: 100%;
    height: 50vh;
    padding: 0 0 0 0;
    position: relative;
    overflow: hidden;
    background-size: cover;
    background-position: center center;
    background-color: ${colors.brand1};
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    @media (min-width: 992px) {
      margin: 0 0 0 0;
      height: 56.25vw;
    }
  }
  .HomePageHeroImage_image {
    width: 100vw;
    height: 50vh;
    object-fit: cover;
    object-position: center center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    @media (min-width: 992px) {
      height: 56.25vw;
    }
  }
  .HomePageHeroImage_overlay {
    content: '';
    position: absolute;
    display: block;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
    background-color: ${colors.black};
    opacity: .4;
    pointer-events: none;
  }
  .HomePageHeroImage_videoWrapper {
    background-size: auto;
    background-repeat: no-repeat;
    background-image: url('/images/video-loading-animation.gif');
  }
  .HomePageHeroImage_headlineWrapper {
    width: 100%;
    padding: 0 0 8vw 0;
    text-align: left;
    z-index: 3;
  }
  .HomePageHeroImage_headlineLine1 {
    text-align: left;
    color: ${colors.white};
    font-family: ${typography.Condensed};
    text-transform: uppercase;
    margin: 0 15px 10px 15px;
    font-size: 36px;
    font-weight: 900;
    letter-spacing: 2px;
    line-height: 1;
    position: relative;
    display: block;
    @media (min-width: 992px) {
      font-size: 120px;
      line-height: .8;
      letter-spacing: 3px;
      margin: 0 0 0 0;
    }
  }
  .HomePageHeroImage_headlineLine2 {
    text-align: left;
    color: ${colors.white};
    font-family: ${typography.Condensed};
    text-transform: uppercase;
    margin: 0 15px 10px 15px;
    font-size: 36px;
    font-weight: 900;
    line-height: 1;
    position: relative;
    display: block;
    @media (min-width: 480px) {
      font-size: 60px;
    }
    @media (min-width: 992px) {
      font-size: 120px;
      line-height: .8;
      margin: 0 0 25px 0;
    }
  }
  .buttonSet__container.center {
    justify-content: flex-start !important;
  }
  .btn {
    padding: 10px 15px !important;
    @media (min-width: 992px) {
      padding: 20px 30px !important;
    }
  }
  .Carousel_imageButtonLeft, .Carousel_imageButtonRight {
    display: none;
    @media (min-width: 767px) {
      display: block;
    }
    @media (min-width: 992px) {
      top: 45%;
    }
  }
`;

const videoCSS = css`
  position: absolute;
  width: 100%;
  padding-top: 50vh;
  top: 0;
  z-index: 1;
  @media (min-width: 992px) {
    padding-top: 56.25vw;
  }
  video {
    object-fit: cover;
    object-position: center;
  }
`;

class HomePageHeroImage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      headerImage: undefined,
    };
  }

  componentDidMount() {
    this.getHeaderImage();
  }

  getHeaderImage() {
    let { headerImage } = this.state;

    if (!headerImage) {
      headerImage = _.sample(_.get(this.props.content, '[0].images'));

      this.setState({
        headerImage: _.get(headerImage, 'contentUrl'),
      });
    }
  }

  render() {
    const { content } = this.props;
    const { headerImage } = this.state;

    return (
      <div
        className={styles}
      >
        {
          _.get(content, '[0].active_section') === 'Video' &&
          <div
            className="HomePageHeroImage_imageWrapper"
          >
            <VideoPlayer
              playing
              playsinline
              muted
              loop
              className={videoCSS}
              url={_.get(content, '[0].video.contentUrl')}
            />
            <div className="HomePageHeroImage_headlineWrapper">
              <div className="container">
                <h2 className="HomePageHeroImage_headline">
                  <span className="HomePageHeroImage_headlineLine1">{_.get(content, '[0].headline')} </span>
                  <span className="HomePageHeroImage_headlineLine2">{_.get(content, '[0].headline_line_2')}</span>
                </h2>
                <ButtonSet buttonSetParent={_.get(content, '[0]')} />
              </div>
            </div>
            {
              (_.get(content, '[0].headline') || _.get(content, '[0].headline_line_2')) &&
              <div className="HomePageHeroImage_overlay" />
            }
          </div>
        }
        {
          _.get(content, '[0].active_section') === 'Image' &&
          <div
            className="HomePageHeroImage_imageWrapper"
          >
            <Image
              className="HomePageHeroImage_image"
              src={headerImage}
              width={2000}
              height={2000}
              alt={_.get(content, '[0].active_section')}
            />
            <div className="HomePageHeroImage_headlineWrapper">
              <div className="container">
                <h2>
                  <span className="HomePageHeroImage_headlineLine1">{_.get(content, '[0].headline')} </span>
                  <span className="HomePageHeroImage_headlineLine2">{_.get(content, '[0].headline_line_2')}</span>
                </h2>
                <ButtonSet buttonSetParent={_.get(content, '[0]')} />
              </div>
            </div>
            {
              (_.get(content, '[0].headline') || _.get(content, '[0].headline_line_2')) &&
              <div className="HomePageHeroImage_overlay" />
            }
          </div>
        }
        {
            _.get(content, '[0].active_section') === 'Carousel' &&
            <Carousel
              autoplay
              interval={6000}
              indicators
              items={_.get(content, '[0].carousel', []).map(item => ({
                element: (
                  <div>
                    {
                      !_.get(item, 'image_link[0].path') &&
                      <div
                        className="HomePageHeroImage_imageWrapper"
                      >
                        <Image
                          className="HomePageHeroImage_image"
                          src={_.get(item, 'image.contentUrl')}
                          width={2000}
                          height={2000}
                          alt={_.get(item, 'image.name', _.get(item, 'image.caption'))}
                        />
                        <div className="HomePageHeroImage_headlineWrapper">
                          <div className="container">
                            <h2>
                              <span className="HomePageHeroImage_headlineLine1">{_.get(item, 'headline')} </span>
                              <span className="HomePageHeroImage_headlineLine2">{_.get(item, 'headline_line_2')}</span>
                            </h2>
                            <ButtonSet buttonSetParent={item} />
                          </div>
                        </div>
                        {
                          (_.get(item, 'headline') || _.get(item, 'headline_line_2')) &&
                          <div className="HomePageHeroImage_overlay" />
                        }
                      </div>
                    }
                    {
                      _.get(item, 'image_link[0].path') &&
                      <RRLink
                        to={_.get(item, 'image_link[0].path')}
                        className="HomePageHeroImage_imageWrapper"
                        style={{ backgroundImage: `url('${_.get(item, 'image.contentUrl')}')` }}
                      >
                        <div className="container">
                          <div className="HomePageHeroImage_headlineWrapper">
                            <h2>
                              <span className="HomePageHeroImage_headlineLine1">{_.get(item, 'headline')} </span>
                              <span className="HomePageHeroImage_headlineLine2">{_.get(item, 'headline_line_2')}</span>
                            </h2>
                            <ButtonSet buttonSetParent={item} />
                          </div>
                        </div>
                        {
                          (_.get(item, 'headline') || _.get(item, 'headline_line_2')) &&
                          <div className="HomePageHeroImage_overlay" />
                        }
                      </RRLink>
                    }
                  </div>
                ),
              }))}
            />
        }
      </div>
    );
  }
}

HomePageHeroImage.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export const sectionName = 'Home Page Hero Image';

export default HomePageHeroImage;



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/HomePageHeroImage2.section.js